(function () {
  'use strict';

  if (window.__ssNavigationRuntimeInstalled) return;
  window.__ssNavigationRuntimeInstalled = true;

  var endpoint = '/apps/product-options';
  var configEndpoint = endpoint + '/config';
  var eventEndpoint = endpoint + '/events';
  var enabled = false;
  var sent = false;

  function clean(value, maxLength) {
    if (value === undefined || value === null) return '';
    return String(value).replace(/\s+/g, ' ').trim().slice(0, maxLength || 256);
  }

  function randomId(prefix) {
    try {
      return prefix + crypto.randomUUID().replace(/-/g, '');
    } catch (_error) {
      return prefix + Date.now().toString(36) + Math.random().toString(36).slice(2);
    }
  }

  function analyticsAllowed() {
    try {
      return Boolean(
        window.Shopify &&
        Shopify.customerPrivacy &&
        typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
        Shopify.customerPrivacy.analyticsProcessingAllowed()
      );
    } catch (_error) {
      return false;
    }
  }

  function browserIdentity() {
    var now = Date.now();
    var visitorId = '';
    var sessionId = '';
    var sessionStartedAt = now;
    try {
      visitorId = clean(window.localStorage.getItem('ss_v2_vid'), 180);
      if (!visitorId) {
        visitorId = randomId('ssv2_');
        window.localStorage.setItem('ss_v2_vid', visitorId);
      }
      var saved = JSON.parse(window.localStorage.getItem('ss_v2_session') || 'null');
      var lastSeenAt = Number(saved && saved.lastSeenAt || 0);
      if (saved && clean(saved.id, 180) && now - lastSeenAt < 30 * 60 * 1000) {
        sessionId = clean(saved.id, 180);
        sessionStartedAt = Number(saved.startedAt || now);
      } else {
        sessionId = randomId('sss2_');
      }
      window.localStorage.setItem('ss_v2_session', JSON.stringify({
        id: sessionId,
        lastSeenAt: now,
        startedAt: sessionStartedAt
      }));
    } catch (_error) {
      visitorId = randomId('ssv2_');
      sessionId = randomId('sss2_');
    }
    return {
      visitorId: visitorId,
      sessionId: sessionId,
      sessionStartedAt: sessionStartedAt
    };
  }

  function pageUrl() {
    try {
      return window.location.origin + window.location.pathname;
    } catch (_error) {
      return '';
    }
  }

  function dispatchPageView() {
    if (sent || !enabled || window.__soulyshineCrmDisabled === true || !analyticsAllowed()) return;
    // Product templates already use product-options-runtime.js. Avoid a second
    // page_viewed row while covering every other storefront template.
    if (/^\/products\//i.test(window.location.pathname || '')) {
      sent = true;
      return;
    }
    sent = true;
    var identity = browserIdentity();
    var eventId = randomId('sse_');
    var payload = {
      eventId: eventId,
      idempotencyKey: 'storefront:' + eventId,
      eventName: 'page_viewed',
      source: 'shopify_pixel',
      visitorId: identity.visitorId,
      sessionId: identity.sessionId,
      occurredAt: new Date().toISOString(),
      properties: {
        bridgeEventId: eventId,
        trackingProducer: 'navigation_bridge',
        pageUrl: pageUrl(),
        pageTitle: clean(document.title, 300),
        referrer: clean(document.referrer, 2048),
        sessionElapsedSeconds: Math.max(0, Math.floor((Date.now() - identity.sessionStartedAt) / 1000))
      }
    };
    try {
      var body = JSON.stringify(payload);
      window.fetch(eventEndpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: true
      }).catch(function () {
        try {
          if (window.navigator && typeof window.navigator.sendBeacon === 'function') {
            window.navigator.sendBeacon(eventEndpoint, new Blob([body], { type: 'application/json' }));
          }
        } catch (_beaconError) {}
      });
    } catch (_error) {}
  }

  function schedulePageView() {
    if (!enabled || !analyticsAllowed()) return;
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(dispatchPageView, { timeout: 1200 });
    } else {
      window.setTimeout(dispatchPageView, 0);
    }
  }

  function consentChanged() {
    if (analyticsAllowed()) schedulePageView();
  }

  function loadConsentApi() {
    if (
      window.Shopify &&
      Shopify.customerPrivacy &&
      typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function'
    ) {
      schedulePageView();
      return;
    }
    if (!window.Shopify || typeof Shopify.loadFeatures !== 'function') return;
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], consentChanged);
  }

  document.addEventListener('visitorConsentCollected', consentChanged, { passive: true });
  document.addEventListener('shopifyCustomerPrivacyApiLoaded', consentChanged, { passive: true });

  window.setTimeout(function () {
    window.fetch(configEndpoint, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('tracking_config_unavailable');
      return response.json();
    }).then(function (config) {
      enabled = Boolean(config && config.trackingEnabled === true);
      if (enabled) loadConsentApi();
    }).catch(function () {
      enabled = false;
    });
  }, 0);
})();
